import axios from "axios";
import { BASE_URL } from "../../config";

export const fetchSaidiDetails = async ({ featureType, featureId, pripadnostVodu = null }) => {
    const response = await axios.post(`${BASE_URL}/api/saidi/details`, {
        feature_type: featureType,
        feature_id: featureId,
        pripadnost_vodu: pripadnostVodu,
    });

    return response.data;
};